var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',_vm._l((this.sections),function(item,index){return _c('div',{staticClass:"single_section section small_pt pb_70"},[_c('section_list',{attrs:{"name":item.name,"id":item.id,"image":item.image,"categories":item.categories}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }